import { Controller } from "@hotwired/stimulus"

// Trägt beim Wählen eines Stundenverrechnungssatzes Einheit und Einheitspreis nach
// (GB-28). Eine Regieposition rechnet Stunden × Satz; beides von Hand nachzuziehen wäre
// die Stelle, an der ein Tippfehler eine ganze Rechnung verschiebt.
//
// Der Server erzwingt dasselbe (Billing::HourlyWorkPosition setzt Einheit und Kostenart
// ohnehin) — hier geht es nur darum, dass das Formular nicht etwas anderes zeigt, als
// gespeichert wird. Ein bereits eingetragener Preis wird NICHT überschrieben: der
// Verkaufspreis ist verhandelbar, und ein abweichender Satz auf einer Position ist ein
// gewollter Fall, kein Fehler.
export default class extends Controller {
  static targets = ["rateSelect"]
  static values = { hourUnit: String }

  connect() {
    this.lockCostType()
  }

  rateChanged() {
    this.lockCostType()

    const option = this.rateSelectTarget.selectedOptions[0]
    if (!option || !option.value) return

    const rate = option.dataset.rate
    this.applyUnit()
    this.applyPrice(rate)
  }

  // Eine Regieposition IST Lohn — Billing::HourlyWorkPosition erzwingt die Kostenart
  // serverseitig. Ohne diese Sperre blieben Kostenart und Lohnanteil daneben frei
  // wählbar, und eine eingestellte "Gemischt / 40 %" käme kommentarlos als "Lohn"
  // zurück: der Eintrag wäre verworfen, ohne dass das Formular es je gesagt hätte.
  // Gesperrt statt nur ausgeblendet, damit der Block nicht mit dem
  // billing-line-item-type-Controller um dieselbe hidden-Klasse streitet.
  lockCostType() {
    const select = this.costTypeSelect
    if (!select) return

    const locked = Boolean(this.rateSelectTarget.value)
    select.disabled = locked
    if (!locked || select.value === "labor") return

    select.value = "labor"
    // Für SlimSelect (sichtbare Beschriftung) und den billing-cost-type-Controller, der
    // daraufhin das Prozentfeld ausblendet und deaktiviert — sonst ginge ein alter
    // Lohnanteil trotzdem mit.
    select.dispatchEvent(new Event("change", { bubbles: true }))
  }

  get costTypeSelect() {
    return this.form?.querySelector('select[name="billing_line_item[cost_type]"]')
  }

  applyUnit() {
    const unitField = this.form?.querySelector('select[name="billing_line_item[unit]"]')
    if (!unitField || unitField.value === this.hourUnitValue) return

    const match = Array.from(unitField.options).find((entry) => entry.value === this.hourUnitValue)
    if (!match) return

    unitField.value = this.hourUnitValue
    // SlimSelect rendert sein eigenes Markup neben dem select — ohne das Event bliebe
    // die sichtbare Beschriftung auf dem alten Wert stehen.
    unitField.dispatchEvent(new Event("change", { bubbles: true }))
  }

  applyPrice(rate) {
    const priceField = this.form?.querySelector('input[name="billing_line_item[unit_price]"]')
    if (!priceField || !rate) return
    if (priceField.value && Number(priceField.value) !== 0) return

    priceField.value = rate
  }

  get form() {
    return this.element.closest("form")
  }
}
